module.exports = __webpack_public_path__ + "static/news_economy.2acfa579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/screenshots/macau/news_economy.jpg
// module id = ./src/app/data/screenshots/macau/news_economy.jpg
// module chunks = 7